import { createSelector } from 'reselect'

import isOwnerSelector from 'redux/selectors/is_owner'
import { canManageVeniceSelector } from 'redux/selectors/venice'

const canManageSelector = createSelector(
  [isOwnerSelector, canManageVeniceSelector],
  (isOwner, canManageVenice) => {
    return isOwner && !canManageVenice
  }
)

export default canManageSelector
